import React from 'react'
import {colors} from '../../sharedComponents/colors'
import styled, {css} from 'styled-components'
import {Text} from '../../sharedComponents/components'
import {useTranslation} from 'react-i18next'

export type SwitchProps = React.InputHTMLAttributes<HTMLInputElement> & {
  option1Text?: string
  option2Text?: string
}

export const checkedColors = {
  default: colors.system.green,
  reversed: colors.system.red
}

export const ColoredTogglerButton: React.FC<SwitchProps> = props => {
  const {t} = useTranslation('common')

  return (
    <SwitchContainer>
      <SwitchInput {...props} type="checkbox"></SwitchInput>
      <Labels>
        {props.option1Text && (
          <Half $side="left" $active={!props.checked}>
            <LabelText size="XS" $active={!props.checked}>
              {props.option1Text}
            </LabelText>
          </Half>
        )}
        {props.option2Text && (
          <Half $side="right" $active={!!props.checked}>
            <LabelText size="XS" $active={!!props.checked}>
              {props.option2Text}
            </LabelText>
          </Half>
        )}
      </Labels>

      <SwitchToggle checked={props.checked} checkedColor={checkedColors.default}></SwitchToggle>
    </SwitchContainer>
  )
}

export const SwitchContainer = styled.label`
  display: inline-block;
  position: relative;
  width: 6rem;
  height: 2rem;
  background-color: ${colors.system.white};
  border-radius: 1rem;
  cursor: pointer;
  border-color: ${colors.system.grey_2};
  border-width: 0.5px;
  border-style: solid;
`

export const SwitchInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`

const Labels = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  z-index: 1;
  pointer-events: none;
`

const Half = styled.div<{$side: 'left' | 'right'; $active: boolean}>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.25rem;
  transition: opacity 0.2s ease;
  opacity: ${({$active}) => ($active ? 1 : 0.6)};
`
const LabelText = styled(Text)<{$active: boolean}>`
  font-size: 0.85rem;
  line-height: 1;
  color: ${({$active}) => ($active ? colors.system.white : colors.system.grey_1)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SwitchToggle = styled.span<{checked?: boolean; checkedColor: string}>(
  ({checked, checkedColor}) => css`
    display: inline-block;
    position: absolute;
    top: 0;
    left: ${checked ? '3rem' : '0'};
    width: 3rem;
    height: 2rem;
    background-color: ${checked ? checkedColor : colors.system.grey_1};
    border-radius: 1rem;
    transition-property: left, background-color;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
  `
)
